import React from "react";
import "./label-round.component.scoped.scss";

export const LabelRoundComponent = (props: any) => {
  const { label } = props;

  return <div className="label-round">{label}</div>;
};
